export const createScript = (id: string, src: string) => {
  const d = document
  const fjs = d.getElementsByTagName('script')[0]
  if (d.getElementById(id)) return
  const js = d.createElement('script')
  js.id = id
  js.src = src
  fjs.parentNode?.insertBefore(js, fjs)
}

export const removeScript = (id: string) => {
  const oldTag = document.getElementById(id)
  if (!oldTag) return
  oldTag.parentNode?.removeChild(oldTag)
}
